Vue.component('cardAbilities', {
  template: templates.cardAbiltities,
  data() {
    return {
      model: {
        edit: false,
        ability: {
          id: null,
          name: null,
          description: null,
          active: false
        },
        abilities: {}
      }
    }
  },
  mounted() {
    const c = this;
    c.get();
  },
  methods: {
    get() {
      const c = this;
      let data = {};

      abilityService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.abilities = data;
          c.$root.$emit('abilities', data);
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    edit(id) {
      const c = this;
      let data = c.model.abilities[`${id}`];

      if (id == c.model.ability.id) {
        c.model.edit = false;
      } else {
        c.model.edit = true;
      }

      c.model.ability = {
        id: id,
        name: data.name,
        description: data.description,
        active: data.active
      }
    },
    add() {
      const c = this;
      c.model.edit = true;
    },
    save() {
      const c = this;

      const data = c.model.ability;

      if (!data.name) {
        utils.alert.error('Name is required');
        return;
      } else if (!data.description) {
        utils.alert.error('Description is required');
        return;
      }
      
      abilityService.save(data)
        .then(function (response) {

          if (data.id) {
            c.model.abilities[`${data.id}`] = data;
          } else {
            data.id = response.data.id;
            c.model.abilities[`${data.id}`] = data;
          }

          c.reset();
          
          utils.alert.success('Saved!');
          
        })
        .catch(function (error) {
          utils.alert.error('Failed to save.');
        });
    },
    reset() {
      const c = this;
      c.model.edit = false;
      
      c.model.ability = {
        id: null,
        name: null,
        description: null,
        active: false
      }
    }
  }
});